/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { z } from "zod";
const base = z.object({
  id: z.number(),
  createdAt: z.number(),
  updatedAt: z.number(),
  material_division_id: z.number(),
  material_id: z.number(),
  mix_ratio_definition_id: z.number(),
  material_detail_id: z.number(),
  ratio_start: z.number(),
  ratio_end: z.number().nullable(),
  deleted_at: z.number().nullable(),
});
const create = base.extend({
});
const update = base.partial();
const put = create.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
});
const patch = base.omit({
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
})
.extend({ id: z.number() })
const rows = z.array(base);
const rowsWithPaging = z.object({
  count: z.number(),
  rows: rows,
});
const cache = base.omit({
}).extend({ cachedAt: z.number() });
const caches = z.array(cache);
export const MixRatioDetailBaseSchema = { base, put, patch, rows, rowsWithPaging, create, update, cache, caches };
export type MixRatioDetailBase = z.infer<typeof base>;
export type MixRatioDetailBasePutPayload = z.infer<typeof put>;
export type MixRatioDetailBasePatchPayload = z.infer<typeof patch>;
export type MixRatioDetailBaseRowsWithPaging = z.infer<typeof rowsWithPaging>;
export type MixRatioDetailBaseCreateAttributes = z.infer<typeof create>;
export type MixRatioDetailBaseUpdateAttributes = z.infer<typeof update>;
export type MixRatioDetailBaseCacheAttributes = z.infer<typeof cache>;
export type MixRatioDetailBaseCachesAttributes = z.infer<typeof caches>;